module.exports = __webpack_public_path__ + "img/500-image-2.78fa46d7.jpg";